import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Roadmap from './pages/Roadmap';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import BusinessBasics from './pages/BusinessBasics';
import CoreValues from './pages/CoreValues';
import Mission from './pages/Mission';
import Vision from './pages/Vision';
import TargetMarketDiscovery from './pages/TargetMarketDiscovery';
import MissionVisionRefinement from './pages/MissionVisionRefinement';
import CustomerJourney from './pages/CustomerJourney';
import ResultsAlignment from './pages/ResultsAlignment';
import CapacityAssessment from './pages/CapacityAssessment';
import ExitStrategy from './pages/ExitStrategy';
import ExitCalculator from './pages/ExitCalculator';
import ViewFoundation from './pages/ViewFoundation';
import ViewBusinessModel from './pages/ViewBusinessModel';
import Welcome from './pages/Welcome';
import CoreProductPricing from './pages/CoreProductPricing';
import RecurringRevenueWorkshop from './pages/RecurringRevenueWorkshop';
import ReferralSource from './pages/ReferralSource';
import CustomerExperience from './pages/CustomerExperience';
import CompetitiveAnalysis from './pages/CompetitiveAnalysis';
import FeaturesBenefits from './pages/FeaturesBenefits';
import ProductRoadmap from './pages/ProductRoadmap';
import ProductCatalog from './pages/ProductCatalog';
import USPCreation from './pages/USPCreation';
import IrresistibleOffer from './pages/IrresistibleOffer';
import FeedbackAdmin from './pages/FeedbackAdmin';
import Admin from './pages/Admin';
import AdminRoadmap from './pages/AdminRoadmap';
import AdminStats from './pages/AdminStats';
import FeedbackButton from './components/FeedbackButton';
import BrandQuizIntro from './pages/BrandQuizIntro';
import BrandQuiz from './pages/BrandQuiz';
import BrandResults from './pages/BrandResults';
import ColorPaletteSelection from './pages/ColorPaletteSelection';
import PaletteCustomization from './pages/PaletteCustomization';
import TypographySelection from './pages/TypographySelection';
import LogoDirection from './pages/LogoDirection';
import LogoUpload from './pages/LogoUpload';
import IconographyStyle from './pages/IconographyStyle';
import BrandStyle from './pages/BrandStyle';
import BrandTexture from './pages/BrandTexture';
import BrandVoiceAnalysis from './pages/BrandVoiceAnalysis';
import VisualMoodBoard from './pages/VisualMoodBoard';
import ViewBrandIdentity from './pages/ViewBrandIdentity';
import MarketingAssessment from './pages/MarketingAssessment';
import MarketingPriorities from './pages/MarketingPriorities';
import ClientRetention from './pages/ClientRetention';
import ViralReferral from './pages/ViralReferral';
import UpdatedExitStrategy from './pages/UpdatedExitStrategy';
import LeadMagnetTopic from './pages/LeadMagnetTopic';
import LeadMagnetContent from './pages/LeadMagnetContent';
import LeadMagnetLanding from './pages/LeadMagnetLanding';
import SalesPage from './pages/SalesPage';
import EmailSequences from './pages/EmailSequences';
import EmailWelcome from './pages/EmailWelcome';
import BattlePlan from './pages/BattlePlan';
import UpgradePaths from './pages/UpgradePaths';
import PlannedPromotions from './pages/PlannedPromotions';
import QuickStart from './pages/QuickStart';
import QuickStartDashboard from './pages/QuickStartDashboard';
import AnalyzeBusiness from './pages/AnalyzeBusiness';
import MindToMethod from './pages/MindToMethod';
import MindToMethodV2 from './pages/MindToMethodV2';
import MindToMethodUnified from './pages/MindToMethodUnified';
import SalesPageAnalyzer from './pages/SalesPageAnalyzer';

// Command Center imports
import CommandCenterLayout from './components/CommandCenterLayout';
import CCDashboard from './pages/command-center/CCDashboard';
import CampaignHQ from './pages/command-center/CampaignHQ';
import ApprovalQueue from './pages/command-center/ApprovalQueue';
import WeeklyReport from './pages/command-center/WeeklyReport';
import ContentCalendar from './pages/command-center/ContentCalendar';
import WarRoom from './pages/command-center/WarRoom';
import ProfitAdvisor from './pages/command-center/ProfitAdvisor';
import ProfitZone from './pages/command-center/ProfitZone';
import AuthorityEngineer from './pages/command-center/AuthorityEngineer';
import AuthorityAudit from './pages/command-center/AuthorityAudit';
import VisibilityCheck from './pages/command-center/VisibilityCheck';
import IPInventory from './pages/command-center/IPInventory';
import GapAnalysis from './pages/command-center/GapAnalysis';
import AmazonPublishing from './pages/command-center/AmazonPublishing';
import IPExtraction from './pages/command-center/IPExtraction';
import ImportIP from './pages/command-center/ImportIP';
import ProcessBuilder from './pages/command-center/ProcessBuilder';
import BookBuilder from './pages/command-center/BookBuilder';
import BookEnhance from './pages/command-center/BookEnhance';
import BookLaunchChecklist from './pages/command-center/BookLaunchChecklist';
import SpeakingTopics from './pages/command-center/SpeakingTopics';
import ContentMatrix from './pages/command-center/ContentMatrix';
import ProductLaunch from './pages/command-center/ProductLaunch';
import SOPAssistant from './pages/command-center/SOPAssistant';
import CaseStudyWriter from './pages/command-center/CaseStudyWriter';
import CCExitStrategy from './pages/command-center/ExitStrategy';
import LifeGoals from './pages/command-center/LifeGoals';
import Calendars from './pages/command-center/Calendars';
import OnboardingStatus from './pages/command-center/OnboardingStatus';
import CCSalesPage from './pages/command-center/CCSalesPage';
import UnifiedSalesPageGenerator from './pages/command-center/UnifiedSalesPageGenerator';
import CCPromotions from './pages/command-center/CCPromotions';
import FunnelManagement from './pages/command-center/FunnelManagement';
import FunnelBuilder from './pages/command-center/FunnelBuilder';
import CCEmailSequences from './pages/command-center/EmailSequences';
import EmailMarketing from './pages/command-center/EmailMarketing';
import SocialModule from './pages/command-center/SocialModule';
import LaunchModule from './pages/command-center/LaunchModule';
import LongFormPosts from './pages/command-center/LongFormPosts';
import ShortFormPosts from './pages/command-center/ShortFormPosts';
import VideoScripts from './pages/command-center/VideoScripts';
import ContentPreferences from './pages/command-center/ContentPreferences';
import Products from './pages/command-center/Products';
import CCProductCatalog from './pages/command-center/CCProductCatalog';
import CCProductSalesPages from './pages/command-center/CCProductSalesPages';
import CCLeadMagnets from './pages/command-center/CCLeadMagnets';
import CCBundles from './pages/command-center/CCBundles';
import CCBonuses from './pages/command-center/CCBonuses';
import CCUpgradePaths from './pages/command-center/CCUpgradePaths';
// Customers hub no longer used directly — Market Intelligence is the parent hub
// import Customers from './pages/command-center/Customers';
import CCCustomerExperience from './pages/command-center/CCCustomerExperience';
import CCCustomerList from './pages/command-center/CCCustomerList';
import BrandKit from './pages/command-center/BrandKit';
import BrandGuide from './pages/command-center/BrandGuide';
import BrandPlaybook from './pages/command-center/BrandPlaybook';
import BrandEngineer from './pages/command-center/BrandEngineer';
import BusinessEngineer from './pages/command-center/BusinessEngineer';
import FinancialEngineer from './pages/command-center/FinancialEngineer';
import MarketIntelligence from './pages/command-center/MarketIntelligence';
import IndustryPulse from './pages/command-center/IndustryPulse';
import OriginStory from './pages/command-center/OriginStory';
import CCSettings from './pages/command-center/Settings';

function App() {
  return (
    <Router>
      <FeedbackButton />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/roadmap" element={<Roadmap />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/:module" element={<Dashboard />} />
        <Route path="/business-basics" element={<BusinessBasics />} />
        <Route path="/core-values" element={<CoreValues />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/target-market-discovery" element={<TargetMarketDiscovery />} />
        <Route path="/mission-vision-refinement" element={<MissionVisionRefinement />} />
        <Route path="/customer-journey" element={<CustomerJourney />} />
        <Route path="/results-alignment" element={<ResultsAlignment />} />
        <Route path="/capacity-assessment" element={<CapacityAssessment />} />
        <Route path="/exit-strategy" element={<ExitStrategy />} />
        <Route path="/exit-calculator" element={<ExitCalculator />} />
        <Route path="/mind2method" element={<MindToMethodUnified />} />
        <Route path="/mind2method-v1" element={<MindToMethod />} />
        <Route path="/mind2method-v2" element={<Navigate to="/mind2method" replace />} />
        <Route path="/view-foundation" element={<ViewFoundation />} />
        <Route path="/view-business-model" element={<ViewBusinessModel />} />
        <Route path="/core-product-pricing" element={<CoreProductPricing />} />
        <Route path="/recurring-revenue-workshop" element={<RecurringRevenueWorkshop />} />
        <Route path="/referral-source" element={<ReferralSource />} />
        <Route path="/customer-experience" element={<CustomerExperience />} />
        <Route path="/competitive-analysis" element={<CompetitiveAnalysis />} />
        <Route path="/features-benefits" element={<FeaturesBenefits />} />
        <Route path="/product-roadmap" element={<ProductRoadmap />} />
        <Route path="/product-catalog" element={<ProductCatalog />} />
        <Route path="/usp-creation" element={<USPCreation />} />
        <Route path="/irresistible-offer" element={<IrresistibleOffer />} />
        <Route path="/feedback-admin" element={<FeedbackAdmin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/roadmap" element={<AdminRoadmap />} />
        <Route path="/admin/stats" element={<AdminStats />} />
        <Route path="/dashboard/brand-quiz-intro" element={<BrandQuizIntro />} />
        <Route path="/dashboard/brand-quiz" element={<BrandQuiz />} />
        <Route path="/dashboard/brand-results" element={<BrandResults />} />
        <Route path="/dashboard/color-palettes" element={<ColorPaletteSelection />} />
        <Route path="/dashboard/palette-customize" element={<PaletteCustomization />} />
        <Route path="/dashboard/typography" element={<TypographySelection />} />
        <Route path="/dashboard/logo-direction" element={<LogoDirection />} />
        <Route path="/dashboard/logo-upload" element={<LogoUpload />} />
        <Route path="/dashboard/iconography" element={<IconographyStyle />} />
        <Route path="/brand-style" element={<BrandStyle />} />
        <Route path="/brand-texture" element={<BrandTexture />} />
        <Route path="/brand-voice-analysis" element={<BrandVoiceAnalysis />} />
        <Route path="/dashboard/mood-board" element={<VisualMoodBoard />} />
        <Route path="/visual-mood-board" element={<VisualMoodBoard />} />
        <Route path="/view-brand-identity" element={<ViewBrandIdentity />} />
        <Route path="/marketing-assessment" element={<MarketingAssessment />} />
        <Route path="/marketing-priorities" element={<MarketingPriorities />} />
        <Route path="/client-retention" element={<ClientRetention />} />
        <Route path="/viral-referral" element={<ViralReferral />} />
        <Route path="/updated-exit-strategy" element={<UpdatedExitStrategy />} />
        <Route path="/lead-magnet-topic" element={<LeadMagnetTopic />} />
        <Route path="/lead-magnet-content" element={<LeadMagnetContent />} />
        <Route path="/lead-magnet-landing" element={<LeadMagnetLanding />} />
        <Route path="/sales-page" element={<SalesPage />} />
        <Route path="/email-sequences" element={<EmailSequences />} />
        <Route path="/email-welcome" element={<EmailWelcome />} />
        <Route path="/battle-plan" element={<BattlePlan />} />
        <Route path="/upgrade-paths" element={<UpgradePaths />} />
        <Route path="/planned-promotions" element={<PlannedPromotions />} />
        <Route path="/quick-start" element={<QuickStart />} />
        <Route path="/quick-start-dashboard" element={<QuickStartDashboard />} />
        <Route path="/analyze-business" element={<AnalyzeBusiness />} />
        <Route path="/check-my-sales-page" element={<SalesPageAnalyzer />} />

        {/* Command Center Routes */}
        <Route path="/command-center" element={<CommandCenterLayout />}>
          <Route index element={<CCDashboard />} />
          <Route path="campaign-hq" element={<CampaignHQ />} />
          <Route path="campaign-hq/approval-area" element={<ApprovalQueue />} />
          <Route path="campaign-hq/weekly-report" element={<WeeklyReport />} />
          <Route path="campaign-hq/content-calendar" element={<ContentCalendar />} />
          <Route path="campaign-hq/sales-page" element={<UnifiedSalesPageGenerator />} />
          <Route path="campaign-hq/promotions" element={<CCPromotions />} />
          <Route path="campaign-hq/funnel-management" element={<FunnelManagement />} />
          <Route path="campaign-hq/funnel/:funnelId" element={<FunnelBuilder />} />
          <Route path="campaign-hq/email" element={<EmailMarketing />} />
          <Route path="campaign-hq/email/sequences" element={<CCEmailSequences />} />
          <Route path="campaign-hq/email-sequences" element={<CCEmailSequences />} />
          <Route path="campaign-hq/social" element={<SocialModule />} />
          <Route path="campaign-hq/social/long-form" element={<LongFormPosts />} />
          <Route path="campaign-hq/social/short-form" element={<ShortFormPosts />} />
          <Route path="campaign-hq/social/video-scripts" element={<VideoScripts />} />
          <Route path="campaign-hq/social/content-preferences" element={<ContentPreferences />} />
          <Route path="campaign-hq/launch" element={<LaunchModule />} />
          <Route path="products" element={<Products />} />
          <Route path="products/catalog" element={<CCProductCatalog />} />
          <Route path="products/sales-pages" element={<UnifiedSalesPageGenerator />} />
          <Route path="products/lead-magnets" element={<CCLeadMagnets />} />
          <Route path="products/bundles" element={<CCBundles />} />
          <Route path="products/bonuses" element={<CCBonuses />} />
          <Route path="products/upgrade-paths" element={<CCUpgradePaths />} />
          <Route path="products/launch" element={<ProductLaunch />} />
          {/* Market Intelligence hub */}
          <Route path="market-intelligence" element={<MarketIntelligence />} />
          <Route path="market-intelligence/customer-list" element={<CCCustomerList />} />
          <Route path="market-intelligence/industry-pulse" element={<IndustryPulse />} />
          {/* Old customer routes → redirect */}
          <Route path="customers" element={<Navigate to="/command-center/market-intelligence" replace />} />
          <Route path="customers/experience" element={<Navigate to="/command-center/business-engineer/customer-experience" replace />} />
          <Route path="market-intelligence/customer-experience" element={<Navigate to="/command-center/business-engineer/customer-experience" replace />} />
          <Route path="customers/list" element={<Navigate to="/command-center/market-intelligence/customer-list" replace />} />

          <Route path="war-room" element={<WarRoom />} />

          {/* Authority Engineer */}
          <Route path="authority-engineer" element={<AuthorityEngineer />} />
          <Route path="authority-engineer/audit" element={<AuthorityAudit />} />
          <Route path="authority-engineer/visibility" element={<VisibilityCheck />} />
          <Route path="authority-engineer/inventory" element={<IPInventory />} />
          <Route path="authority-engineer/gaps" element={<GapAnalysis />} />
          <Route path="authority-engineer/amazon-publishing" element={<AmazonPublishing />} />
          <Route path="authority-engineer/extract" element={<IPExtraction />} />
          <Route path="authority-engineer/import-ip" element={<ImportIP />} />
          <Route path="authority-engineer/processes" element={<ProcessBuilder />} />
          <Route path="authority-engineer/book" element={<BookBuilder />} />
          <Route path="authority-engineer/book/:bookId/enhance" element={<BookEnhance />} />
          <Route path="authority-engineer/book-launch" element={<BookLaunchChecklist />} />
          <Route path="authority-engineer/speaking" element={<SpeakingTopics />} />
          <Route path="authority-engineer/content" element={<ContentMatrix />} />

          {/* Brand Engineer */}
          <Route path="brand-engineer" element={<BrandEngineer />} />
          <Route path="brand-engineer/brand-kit" element={<BrandKit />} />
          <Route path="brand-engineer/brand-strategy-guide" element={<BrandGuide />} />
          <Route path="brand-engineer/brand-playbook" element={<BrandPlaybook />} />
          <Route path="brand-kit" element={<Navigate to="/command-center/brand-engineer/brand-kit" replace />} />
          <Route path="brand-guide" element={<Navigate to="/command-center/brand-engineer/brand-strategy-guide" replace />} />

          {/* Business Engineer hub */}
          <Route path="business-engineer" element={<BusinessEngineer />} />
          <Route path="business-engineer/profit-advisor" element={<ProfitAdvisor />} />
          <Route path="business-engineer/sop-assistant" element={<SOPAssistant />} />
          <Route path="business-engineer/case-study" element={<CaseStudyWriter />} />
          <Route path="business-engineer/profit-zone" element={<ProfitZone />} />
          <Route path="business-engineer/customer-experience" element={<CCCustomerExperience />} />
          {/* Old direct routes → redirect */}
          <Route path="profit-advisor" element={<Navigate to="/command-center/business-engineer/profit-advisor" replace />} />
          <Route path="sop-assistant" element={<Navigate to="/command-center/business-engineer/sop-assistant" replace />} />
          <Route path="case-study" element={<Navigate to="/command-center/business-engineer/case-study" replace />} />
          <Route path="profit-zone" element={<Navigate to="/command-center/business-engineer/profit-zone" replace />} />

          {/* Financial Engineer hub */}
          <Route path="financial-engineer" element={<FinancialEngineer />} />
          <Route path="financial-engineer/exit-strategy" element={<CCExitStrategy />} />
          <Route path="financial-engineer/life-goals" element={<LifeGoals />} />
          {/* Old direct routes → redirect */}
          <Route path="exit-strategy" element={<Navigate to="/command-center/financial-engineer/exit-strategy" replace />} />
          <Route path="life-goals" element={<Navigate to="/command-center/financial-engineer/life-goals" replace />} />

          <Route path="calendars" element={<Calendars />} />
          <Route path="onboarding" element={<OnboardingStatus />} />
          <Route path="origin-story" element={<OriginStory />} />
          <Route path="settings" element={<CCSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
